import axios from "axios";

const host = window.location.hostname;

const environments = {
  "scai.arjtech.xyz": {
    api: "https://arjtech.xyz/scai_backend/api/",
    img: "https://arjtech.xyz/scai_backend",
  },
  "tifa.arjtech.xyz": {
    api: "https://arjtech.xyz/tifa_scai_backend/api/",
    img: "https://arjtech.xyz/tifa_scai_backend",
  },
  "kuchaman.arjtech.xyz": {
    api: "https://kuchaman_api.arjtech.xyz/api/",
    img: "https://kuchaman_api.arjtech.xyz",
  },
  "scaiarj.co.in": {
    api: "https://scaiarj.co.in/scaiarj_backend/api/",
    img: "https://scaiarj.co.in/scaiarj_backend",
  },
  "test.scaiarj.co.in": {
    api: "https://scaiarj.co.in/test_scai_backend/api/",
    img: "https://scaiarj.co.in/test_scai_backend",
  },
};

const config = environments[host] || {
  // api: "https://arjtech.xyz/tifa_scai_backend/api/",
  api: "http://127.0.0.1:8000/api/",
  img: "http://127.0.0.1:8000",

  // api: "http://192.168.29.241/api/",
  // img: "http://192.168.29.241:8000",
};

export const apiUrl = config.api;
export const imgBaseUrl = config.img;

export const api = axios.create({
  baseURL: apiUrl,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

const getStorage = (key) => {
  try {
    return JSON.parse(localStorage.getItem(key) || "{}");
  } catch {
    return {};
  }
};

let cachedIp = null;

export const getIpAddress = async () => {
  if (cachedIp) return cachedIp;

  try {
    const { data } = await axios.get("https://api.ipify.org?format=json");

    cachedIp = data?.ip || "";

    return cachedIp;
  } catch (error) {
    console.error("IP Fetch Error:", error);
    return "";
  }
};

let cachedLocation = null;

export const getLocation = () => {
  return new Promise((resolve) => {
    if (cachedLocation) {
      resolve(cachedLocation);
      return;
    }

    if (!navigator.geolocation) {
      resolve({
        latitude: "",
        longitude: "",
      });
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        cachedLocation = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        };
        resolve(cachedLocation);
      },
      () => {
        resolve({
          latitude: "",
          longitude: "",
        });
      },
      {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 300000,
      },
    );
  });
};

api.interceptors.request.use(
  async (config) => {
    const user = getStorage("user_data");
    const client = getStorage("client");

    if (!client?.username) {
      window.location.replace("/user/verify");
      return Promise.reject("Client not verified");
    }

    if (!user?.remember_token) {
      window.location.replace("/login");
      return Promise.reject("User not logged in");
    }

    const [ip, location] = await Promise.all([getIpAddress(), getLocation()]);

    const extraData = {
      username: client.username,
      user_type: "teacher",
      ip,
      latitude: location.latitude,
      longitude: location.longitude,
    };

    const method = (config.method || "").toLowerCase();

    if (["post", "put", "patch"].includes(method)) {
      if (config.data instanceof FormData) {
        Object.entries(extraData).forEach(([key, value]) => {
          config.data.set(key, value ?? "");
        });
      } else {
        config.data = {
          ...(config.data || {}),
          ...extraData,
        };
      }
    }

    if (method === "get") {
      config.params = {
        ...(config.params || {}),
        ...extraData,
      };
    }

    config.headers.Authorization = `Bearer ${user.remember_token}`;
    config.headers.Accept = "application/json";
    config.headers["x-client-username"] = client.username;
    config.headers["x-client-id"] = client.id;
    config.headers["x-user-id"] = user.id;
    config.headers["x-user-type"] = "teacher";
    config.headers["x-type"] = "software";

    return config;
  },
  (error) => Promise.reject(error),
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      const client = localStorage.getItem("client");
      localStorage.clear();
      if (client) {
        localStorage.setItem("client", client);
      }
      window.location.replace("/login");
    }
    return Promise.reject(error);
  },
);
